// frontend/src/modules/folha/components/HoleriteDetalhes.js
import React from 'react';

function HoleriteDetalhes({ dados, formatCurrency }) {
  // Dividir em proventos e descontos
  const proventos = [
    { label: 'Salário Base', value: dados.salario_base, type: 'provento' },
    { label: 'Horas Extras', value: dados.horas_extras || 0, type: 'provento' },
    { label: 'Adicional Noturno', value: dados.adicional_noturno || 0, type: 'provento' },
    { label: 'Comissões', value: dados.comissoes || 0, type: 'provento' },
    { label: 'Bonificações', value: dados.bonificacoes || 0, type: 'provento' },
    { label: 'Férias', value: dados.ferias || 0, type: 'provento' },
    { label: '13º Salário', value: dados.decimo_terceiro || 0, type: 'provento' },
  ];

  const descontos = [
    { label: 'INSS', value: dados.inss || 0, type: 'desconto' },
    { label: 'IRRF', value: dados.irrf || 0, type: 'desconto' },
    { label: 'Adiantamentos', value: dados.total_adiantamentos || 0, type: 'desconto' },
    { label: 'Vale Transporte', value: dados.vale_transporte || 0, type: 'desconto' },
    { label: 'Vale Alimentação', value: dados.vale_alimentacao || 0, type: 'desconto' },
    { label: 'Plano de Saúde', value: dados.plano_saude || 0, type: 'desconto' },
    { label: 'Outros Descontos', value: dados.outros_descontos || 0, type: 'desconto' },
  ];

  const totalProventos = proventos.reduce((acc, item) => acc + (item.value || 0), 0);
  const totalDescontos = descontos.reduce((acc, item) => acc + (item.value || 0), 0);
  const valorLiquido = totalProventos - totalDescontos;

  return (
    <div style={{ marginBottom: '20px' }}>
      <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '14px' }}>
        <thead>
          <tr style={{ backgroundColor: '#f8f9fa' }}>
            <th style={{ padding: '10px', textAlign: 'left', borderBottom: '2px solid #333' }}>
              <span style={{ color: '#28a745' }}>📈 PROVENTOS</span>
            </th>
            <th style={{ padding: '10px', textAlign: 'right', borderBottom: '2px solid #333' }}>
              <span style={{ color: '#28a745' }}>Valor</span>
            </th>
          </tr>
        </thead>
        <tbody>
          {proventos.filter(item => item.value > 0).map((item, index) => (
            <tr key={index} style={{ borderBottom: '1px solid #dee2e6' }}>
              <td style={{ padding: '8px' }}>{item.label}</td>
              <td style={{ padding: '8px', textAlign: 'right', color: '#28a745' }}>
                {formatCurrency(item.value)}
              </td>
            </tr>
          ))}
          <tr style={{ fontWeight: 'bold', backgroundColor: '#f0fdf4' }}>
            <td style={{ padding: '10px', borderTop: '2px solid #28a745' }}>
              Total Proventos
            </td>
            <td style={{ padding: '10px', textAlign: 'right', borderTop: '2px solid #28a745', color: '#28a745' }}>
              {formatCurrency(totalProventos)}
            </td>
          </tr>
        </tbody>
      </table>

      <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '14px', marginTop: '20px' }}>
        <thead>
          <tr style={{ backgroundColor: '#f8f9fa' }}>
            <th style={{ padding: '10px', textAlign: 'left', borderBottom: '2px solid #333' }}>
              <span style={{ color: '#dc3545' }}>📉 DESCONTOS</span>
            </th>
            <th style={{ padding: '10px', textAlign: 'right', borderBottom: '2px solid #333' }}>
              <span style={{ color: '#dc3545' }}>Valor</span>
            </th>
          </tr>
        </thead>
        <tbody>
          {descontos.filter(item => item.value > 0).map((item, index) => (
            <tr key={index} style={{ borderBottom: '1px solid #dee2e6' }}>
              <td style={{ padding: '8px' }}>{item.label}</td>
              <td style={{ padding: '8px', textAlign: 'right', color: '#dc3545' }}>
                {formatCurrency(item.value)}
              </td>
            </tr>
          ))}
          <tr style={{ fontWeight: 'bold', backgroundColor: '#fdf0f0' }}>
            <td style={{ padding: '10px', borderTop: '2px solid #dc3545' }}>
              Total Descontos
            </td>
            <td style={{ padding: '10px', textAlign: 'right', borderTop: '2px solid #dc3545', color: '#dc3545' }}>
              {formatCurrency(totalDescontos)}
            </td>
          </tr>
        </tbody>
      </table>

      {/* Valor Líquido - Destaque */}
      <div style={{
        marginTop: '20px',
        padding: '15px',
        backgroundColor: '#e3f2fd',
        borderRadius: '8px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        border: '2px solid #007bff'
      }}>
        <div>
          <strong style={{ fontSize: '16px' }}>💰 Valor Líquido a Receber</strong>
          <p style={{ margin: '0', fontSize: '12px', color: '#6c757d' }}>
            Proventos - Descontos
          </p>
        </div>
        <div style={{ fontSize: '24px', fontWeight: 'bold', color: '#007bff' }}>
          {formatCurrency(valorLiquido)}
        </div>
      </div>
    </div>
  );
}

export default HoleriteDetalhes;